import { Component } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import {MatExpansionModule} from '@angular/material/expansion';
import { InnerHTMLPipe } from 'app/core/pipes/innerHTML.pipe';
import { MatIconModule } from '@angular/material/icon';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';


@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, NgFor, InnerHTMLPipe, MatIconModule],
  templateUrl: './terms-and-conditions.component.html',
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden',
        padding: '0'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'hidden',
        padding: '*'
      })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out'))
    ])
  ]
})
export class TermsAndConditionsComponent {
  
  public termsAndConditions: string;
  public termsAndConditionsCategories: any[] = [];
  public panelOpenState = false;
  public catOpen = false;
  catOpenMap: { [key: number]: boolean } = {};
  tcOpenMap: { [catIndex: number]: { [tcIndex: number]: boolean } } = {};
  public loading: boolean = true;

  
  /**
   * Constructor
  */
 constructor(
   private _strapiService: StrapiService
  )
  {
  }
  
  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  
  /**
   * On init
  */
 ngOnInit(): void
 {
   
   // get content from Strapi
   this._strapiService.getTermsAndConditionsScreenContent()
   .subscribe({
     next: (res: any) => {
       //Sorting by render priority (asc)
       this.termsAndConditions = res.data.sort((a, b) => a.renderPriority - b.renderPriority);
      }
    });
    
    // get categories from Strapi
    this._strapiService.getTermsAndConditionsCategories()
    .subscribe({
      next: (res: any) => {
        //Sorting by render priority (asc)
        this.termsAndConditionsCategories = res.data.sort((a, b) => a.renderPriority - b.renderPriority);
        this.termsAndConditionsCategories.forEach(category => {
          category.terms_and_conditions.sort((a, b) => a.renderPriority - b.renderPriority);
        });
        this.loading = false
      }
    });
    
  }


  toggleCategory(index: number): void {
    this.catOpenMap[index] = !this.catOpenMap[index];
  }

  toggleTc(catIndex: number, tcIndex: number): void {
    if (!this.tcOpenMap[catIndex]) {
      this.tcOpenMap[catIndex] = {};
    }
    this.tcOpenMap[catIndex][tcIndex] = !this.tcOpenMap[catIndex][tcIndex];
  }
}
